import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import $ from "jquery";
import {
  login,
  setIsSuccessPayment,
  setAuthUser,
  setAuthToken,
  setExpiresIn,
  setTokenCreatedAt,
  fetchAutoAuthUser,
  fetchFiduciary,
  setJwtToken,
  setAuthGoPeopleUserId,
  setAuthGoPeopleCommunityId,
  setAuthGoPeopleOrganizationId,
  updateSelectedOrganization,
  setCommunitySwitchRequested,
  setCommunityOld,
  autoLoginWithTtp,
  fetchAuthUser,
  setAutoLoging,
  setCurrentPortal
} from "../../store";
import {
  logout,
  decryptWithAES,
  authHasExpired,
  getAuthInfosFromCookie,
  updateAuthCookieGoPeopleOrganizationId,
} from "../../utils";
import {
  refreshAccessToken
} from "../../api";
import _ from "../../i18n";
import Menu from "./Menu";
import Footer from "./Footer";
import {
  TTP_UA_HOME_URL,
} from "../../config";

const Layout = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const folder = useSelector((state) => state.folder);
  const hideFooter = useSelector((state) => state.params.hideFooter);
  const { navCommunity, user, communitySwitchRequested, autoLoging, communityOld } = auth;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [autoLogingstate, setAutoLogingstate] = useState(false);
  useEffect(() => {
    const initAuth = async () => {
      try {
        const authInfos = getAuthInfosFromCookie();

        let jwtToken = authInfos?.jwtToken || authInfos?.jwt || user?.jwtToken || user?.jwt;
        if (authInfos) {
          if (authInfos.token) {
            if (!jwtToken || !authInfos.refreshToken) {
              let autoLoginInfo = dispatch(autoLoginWithTtp(authInfos));
              authInfos.jwtToken = autoLoginInfo.jwtToken;
            }
          }
        }

        if (!authHasExpired(authInfos)) {
          dispatch(setAuthToken(authInfos.token));
          dispatch(setExpiresIn(authInfos.expiresIn));
          dispatch(setTokenCreatedAt(authInfos.createdAt));
          dispatch(setJwtToken(jwtToken));
          dispatch(setAuthGoPeopleUserId(authInfos.userGoApiId));
          dispatch(setAuthGoPeopleCommunityId(authInfos.communityGoApiId));
          dispatch(
            setAuthGoPeopleOrganizationId(authInfos.goPeopleOrganizationId)
          );
          console.log(
            "Auth infos are valid, fetching user and fiduciary...",
            authInfos
          );
          dispatch(fetchAuthUser(authInfos));
          dispatch(fetchFiduciary());

          return;
        }

        if (authInfos && authInfos.refreshToken) {
          console.log("JWT expired — attempting refresh...", authInfos.refreshToken);

          try {
            const tokens = await refreshAccessToken(authInfos.refreshToken);

            const updatedAuth = {
              ...authInfos,
              jwtToken: tokens.accessToken,
              refreshToken: tokens.refreshToken,
              createdAt: Math.floor(Date.now() / 1000),
            };

            // updateAuthCookie(updatedAuth);

            dispatch(setJwtToken(tokens.accessToken));
            dispatch(setAuthToken(updatedAuth.token));
            dispatch(setExpiresIn(updatedAuth.expiresIn));
            dispatch(setTokenCreatedAt(updatedAuth.createdAt));
            dispatch(setAuthGoPeopleUserId(updatedAuth.userGoApiId));
            dispatch(setAuthGoPeopleCommunityId(updatedAuth.communityGoApiId));

            await dispatch(fetchAuthUser(updatedAuth));
            await dispatch(fetchFiduciary());


            return;
          } catch (refreshError) {
            console.log("Refresh failed — fallback to public token");
          }
        }

        // const resp = await getPublicClientCredential();
        // const helpResp =
        //   typeof resp === "string" ? JSON.parse(resp) : resp;

        // const token = helpResp.token.access_token;
        // dispatch(setAuthToken(token));
      } catch (error) {
        console.error("Auth initialization failed:", error);
      }
    };

    initAuth();
  }, []);

  useEffect(() => {
    const authInfos = getAuthInfosFromCookie();
    if (!navCommunity?.uuid) return;
    if (!navCommunity) return;
    // if (prevUuidRef.current === navCommunity.uuid) return;

    // prevUuidRef.current = navCommunity.uuid;
    if (navCommunity) {
      dispatch(
        updateSelectedOrganization({
          uuid: navCommunity.uuid,
          community: navCommunity.communityUuid,
          savedJwt: authInfos.jwtToken,
          goPeopleUserId: authInfos.userGoApiId,
        })
      )
        .unwrap()
        .then(({ communityUuid, organizationUuid, organizationApiId }) => {
          if (!organizationUuid) return;
          dispatch(fetchAuthUser(user));
          updateAuthCookieGoPeopleOrganizationId(
            null,
            organizationUuid,
            organizationApiId
          );
          if (communitySwitchRequested) {
            window.location.replace("/");
          }
        })
        .catch((err) => {
          console.error("updateSelectedOrganization failed", err);
        });
      // updateAuthCookieGoPeopleOrganizationId(navCommunity.uuid, navCommunity.selectedOrganization.uuid)
      dispatch(setAuthToken(authInfos.token));
      dispatch(setExpiresIn(authInfos.expiresIn));
      dispatch(setTokenCreatedAt(authInfos.createdAt));
      dispatch(setJwtToken(authInfos.jwtToken));
      dispatch(setAuthGoPeopleUserId(authInfos.userGoApiId));
      dispatch(setAuthGoPeopleCommunityId(navCommunity.uuid));
      dispatch(
        setAuthGoPeopleOrganizationId(navCommunity.selectedOrganization?.uuid)
      );

      // console.log("Community switch requested: saaaaaaaaaarrrrrr 11111111111", communityOld, navCommunity);
      if (communityOld && navCommunity?.uuid !== communityOld) {
        dispatch(setCommunitySwitchRequested(true));
        dispatch(setCommunityOld(navCommunity?.uuid));
      } else if (!communityOld) {
        dispatch(setCommunityOld(navCommunity?.uuid));
      }

      // if (navCommunity.selectedOrganization) {
      //   dispatch(setAuthGoPeopleOrganizationId(navCommunity.selectedOrganization.selected_organization ? navCommunity.selectedOrganization.selected_organization.uuid : navCommunity.selectedOrganization.uuid));
      //   // fetchFiduciary();
      // }
    }


  }, [navCommunity?.uuid]);
  useEffect(() => {
    if (!communitySwitchRequested) return;

    if (!folder.fiduciary) return;

    if (folder.fiduciary.uaMode === "COMMUNITY") {
      dispatch(setCurrentPortal("SETTINGS"));
      navigate("/settings");
    } else {
      dispatch(setCurrentPortal("COLLABORATOR"));
      navigate("/collaborator");
    }

    dispatch(setCommunitySwitchRequested(false));

  }, [navCommunity?.uuid, folder.fiduciary]);
  useEffect(() => {
    if (!auth.user) return;

    if (folder.fetching) return;

    if (!folder.fetched) return;

    if (!folder.fiduciary) return;

    console.log("auth.autoLoging:", auth.autoLoging, autoLoging);
    if (auth.user && auth.user.role && !auth.autoLoging && !autoLogingstate) {
      // if (
      //   folder.fetched &&
      //   folder.fiduciary &&
      //   folder.fiduciary.subscription &&
      //   !["PENDING", "IN_PROGRESS"].includes(folder.fiduciary.subscription) &&
      //   location.pathname !== "/account-activation"
      // ) {
      //   navigate("/account-suspended");
      //   return null;
      // }
      if (
        folder.fetched &&
        folder.fiduciary &&
        folder.fiduciary?.uaHasAccess === false &&
        !["/subscriptions", "/invoices"].includes(location.pathname)
      ) {
        navigate("/account-suspended");
        return null;
      }
      if (auth.user.role.typeStatus === "FOLDER") {
        navigate("/client");
      } else {
        if (folder.fiduciary && folder.fiduciary.uaMode === "COMMUNITY") {
          // navigate("/settings");
          // } else {
          //   navigate("/collaborator");
        }
      }
      if (auth.user.role.type === "OFFICIAL") {
        navigate({
          pathname: "/collaborator",
          search: searchParams.toString(),
        });
        return null;
      } else if (auth.user.role.typeStatus === "FOLDER") {
        navigate({
          pathname: "/client",
          search: searchParams.toString(),
        });
        return null;
      }
    }
    if (auth.user && folder.fetched && !autoLoging && !autoLogingstate) {
      if (!folder.fiduciary) {
        navigate("/create-office");
      } else if (folder.fiduciary) {
        if (
          folder.fiduciary.uaStatus === "CREATED" ||
          folder.fiduciary.uaStatus === "DELETED"
        ) {
          navigate("/create-office");
        } else if (folder.fiduciary.uaStatus === "PENDING") {
          navigate("/pending");
        } else if (folder.fiduciary.uaStatus === "VALIDATED") {
          if (searchParams.get("ps")) {
            dispatch(setIsSuccessPayment(true));
          }
          if (folder.fiduciary.onBoardingStep === "CREATED") {
            navigate("/welcome");
          } else if (folder.fiduciary.onBoardingStep !== "COMPLETE") {
            navigate("/join");
          }
        }
      }
    }
  }, [auth, folder]);

  useEffect(() => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        if (error.response.status === 401) {
          dispatch(setAuthUser(null));
          logout(false);
          // navigate("/");
           window.location.assign(`${TTP_UA_HOME_URL}`);
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    let authInfos = null;
    const params = new URLSearchParams(window.location.search).get("params");
    if (params) {
      const decryptedParams = JSON.parse(decryptWithAES(params));
      if (
        decryptedParams["token"] &&
        decryptedParams["userId"] &&
        decryptedParams["tokenCreatedAt"] &&
        decryptedParams["tokenExpiresIn"]
      ) {
        dispatch(setAuthUser(null));
        logout(false);
        authInfos = {
          id: decryptedParams["userId"],
          token: decryptedParams["token"],
          createdAt: decryptedParams["tokenCreatedAt"],
          expiresIn: decryptedParams["tokenExpiresIn"],
        };
        console.log("authInfos from decrypted params: ========", authInfos);
        dispatch(setAuthToken(authInfos.token));
        if (authInfos) {
          dispatch(autoLoginWithTtp(authInfos));
        }
        dispatch(
          fetchAutoAuthUser({
            user: authInfos,
            fiduciaryId: decryptedParams["id"] ?? null,
          })
        );
        dispatch(setExpiresIn(authInfos.expiresIn));
        dispatch(setTokenCreatedAt(authInfos.createdAt));
        dispatch(fetchFiduciary());
      }
    }

    if (!authInfos) {
      dispatch(login());
    }

    if (!auth.user) {
      $("#app-loader")
        .fadeOut()
        .promise()
        .done(() => $("#app-loader").remove());
    }
  }, []);

  if (!folder.fetched && !folder.fetching) {
    return null;
  }

  const withoutFooterURL = [
    "/join",
    "/create-office",
    "/welcome",
    "/account-activation",
  ];

  if (hideFooter && location.pathname === "/collaborator") {
    withoutFooterURL.push(location.pathname);
  }

  return (
    <div>
      <Menu />
      <Outlet />
      {!withoutFooterURL.includes(location.pathname) &&
        folder.fiduciary &&
        folder.fiduciary.id !== 4 && <Footer />}
    </div>
  );
};

export default Layout;
